import * as React from 'react';
import * as styles from './FontStyle.css';
import { IAIcon } from '../icon/Icon';

export interface IFontStyleProps {
  label: string;
  fontWeight: string;
  fontStyle?: string;
  selectedColor: string;
  align?: string;
  fontSize?: number;
  styles?: any;
  setFontWeight?: (type: string) => void;
  setFontStyle?: (style: string) => void;
  setFontAlign?: (align: string) => void;
  setFontSize?: (size: number) => void;
}

export interface IFontStyleState {
}

export class IAFontStyle extends React.Component<IFontStyleProps, IFontStyleState> {

  constructor(props: IFontStyleProps) {
    super(props);
    this.state = {
    };
  }

  private setFontWeight(fontWeight: string): void {
    this.props.setFontWeight(fontWeight);
  }

  // private setFontStyle(fontStyle: string): void {
  //   this.setState({ fontStyle });
  //   this.props.setFontStyle(fontStyle);
  // }

  // private setFontSize(fontSize: number): void {
  //   this.setState({ fontSize });
  //   this.props.setFontSize(fontSize);
  // }

  private setFontAlign(align: string): void {
    this.props.setFontAlign(align);
  }

  public render(): JSX.Element {
    return (
      <div
        style={this.props.styles}>
        {/* <div>
          <IANumberField
            label={this.props.label}
            number={this.props.fontSize}
            onChange={this.setFontSize.bind(this)}
            styles={{
              width: "100%"
            }}
          />
        </div> */}
        <div className={styles.IA_fontStyleButtons}>
          <div
            className={styles.IA_fontWeightButton + " " + styles.regular}
            style={{
              border: this.props.fontWeight === "normal" || this.props.fontWeight == undefined ? `1px solid ${this.props.selectedColor}` : "1px solid #dddddd"
            }}
            onClick={() => this.setFontWeight("normal")}
          >Aa</div>
          {/* <div
            className={styles.IA_fontWeightButton + " " + styles.mediumBold}
            style={{
              backgroundColor: this.state.fontWeight === "mediumBold" ? `${this.props.selectedColor}30` : "#ffffff",
              border: this.state.fontWeight === "mediumBold" ? `1px solid ${this.props.selectedColor}` : "1px solid #dddddd",
            }}
            onClick={() => this.setFontWeight("mediumBold")}
          >Aa</div> */}
          <div
            className={styles.IA_fontWeightButton + " " + styles.bold}
            style={{
              border: this.props.fontWeight === "bold" ? `1px solid ${this.props.selectedColor}` : "1px solid #dddddd"
            }}
            onClick={() => this.setFontWeight("bold")}
          >Aa</div>
          {/* <div
            className={styles.IA_fontStyleButton + " " + styles.italic}
            style={{
              backgroundColor: this.state.fontStyle === "italic" ? `${this.props.selectedColor}30` : "#ffffff",
              border: this.state.fontStyle === "italic" ? `1px solid ${this.props.selectedColor}` : "1px solid #dddddd",
            }}
            onClick={() => {
              if (this.state.fontStyle === "italic") {
                this.setFontStyle("normal");
              } else {
                this.setFontStyle("italic");
              }
            }}
          >I</div> */}
          <div
            className={styles.IA_fontWeightButton}
            style={{
              border: this.props.align === "left" || this.props.fontWeight == undefined ? `1px solid ${this.props.selectedColor}` : "1px solid #dddddd",
              lineHeight: "40px",
              marginLeft: 20  
            }}
            onClick={() => this.setFontAlign("left")}
          >
            <IAIcon
              title="TextAlignLeft"
              size={20}
              color="#025159"
              style={{
              }} />
          </div><div
            className={styles.IA_fontWeightButton}
            style={{
              border: this.props.align === "center" ? `1px solid ${this.props.selectedColor}` : "1px solid #dddddd",
              lineHeight: "40px"
            }}
            onClick={() => this.setFontAlign("center")}
          >
            <IAIcon
              title="TextAlignCenter"
              size={20}
              color="#025159"
              style={{
              }} />
          </div>
          <div
            className={styles.IA_fontWeightButton}
            style={{
              border: this.props.align === "right" ? `1px solid ${this.props.selectedColor}` : "1px solid #dddddd",
              lineHeight: "40px"
            }}
            onClick={() => this.setFontAlign("right")}
          >
            <IAIcon
              title="TextAlignRight"
              size={20}
              color="#025159"
              style={{
              }} />
          </div>
        </div>
      </div>
    );
  }
}